import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5118b5fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__goal-management px-12 pb-30" }
const _hoisted_2 = { class: "__goal-management__header pt-10 pb-10 flex flex-nowrap justify-between items-center" }
const _hoisted_3 = { class: "__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl" }
const _hoisted_4 = { class: "search-input w-ful" }
const _hoisted_5 = { class: "input-group input--lg" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  placeholder: "Gõ tên học sinh để bắt đầu tìm kiếm",
  class: "bg-white input-with-icon"
}, null, -1))
const _hoisted_7 = { class: "input-icon absolute top-1/2" }
const _hoisted_8 = { class: "__goal-management__container" }
const _hoisted_9 = { class: "shadow-sm sm:rounded-2xl mt-10 overflow-hidden" }
const _hoisted_10 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_11 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_12 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-32"
    }, " Tên học sinh "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
    }, " Tỷ lệ hoàn thành M.T "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
    }, " Sự tham gia "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
    }, " Cảm xúc "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-32" })
  ])
], -1))
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 h-6 w-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-6 w-6 rounded-full",
    src: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60",
    alt: ""
  })
], -1))
const _hoisted_17 = { class: "ml-4 truncate" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }, [
  /*#__PURE__*/_createElementVNode("div", null, "5")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }, [
  /*#__PURE__*/_createElementVNode("div", null, "1")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }, [
  /*#__PURE__*/_createElementVNode("div", null, "4")
], -1))
const _hoisted_21 = { class: "flex flex-nowrap items-center" }
const _hoisted_22 = { class: "p-2 mr-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "luca-tooltip" }, " Xem lịch học ", -1))
const _hoisted_24 = { class: "p-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "luca-tooltip" }, " Xem hồ sơ chi tiết ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DaIcon, {
          name: "das--class-dairy",
          class: "mr-3 h-6 w-6"
        }),
        _createTextVNode(" Nhật ký học tập ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DaIcon, {
              name: "das--search",
              class: "h-4 w-4 text-neutral-400"
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.people, (person, personIdx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: person.id,
                    class: _normalizeClass([
										personIdx % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									, "text-neutral-700"])
                  }, [
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, _toDisplayString(person.name), 1)
                      ])
                    ]),
                    _hoisted_18,
                    _hoisted_19,
                    _hoisted_20,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_Popper, {
                            placement: "top",
                            hover: "",
                            arrow: true
                          }, {
                            content: _withCtx(() => [
                              _hoisted_23
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_DaIcon, {
                                name: "das--calender",
                                class: "h-4 w-4 text-yellow-600 hover:text-yellow-900 active:text-yellow-500 cursor-pointer"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_Popper, {
                            placement: "top",
                            hover: "",
                            arrow: true
                          }, {
                            content: _withCtx(() => [
                              _hoisted_25
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: `/goal-management/${person.id}`
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DaIcon, {
                                    name: "das--chevron-down",
                                    class: "h-4 w-4 text-blue-600 hover:text-blue-900 active:text-blue-500 cursor-pointer transform -rotate-90"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}